// Assinatura na tela (P0.7). Com a tela de assinatura aberta, consulta a cada 5 s:
// pagamento aprovado libera o acesso em até 10 s em todos os dispositivos (ASM-051).
import { useEffect } from 'react';
import { hasAccess, isPaying, neverSubscribed, subscriptionEnded } from '../domain/access';
import { useAppState, useStore } from './AppStore';
import { useNow } from './useNow';

export const POLL_MS = 5000;

export function useSubscriptionPolling(active: boolean, intervalMs = POLL_MS): void {
  const store = useStore();
  useEffect(() => {
    if (!active) return;
    const id = setInterval(() => void store.refreshSubscription(), intervalMs);
    return () => clearInterval(id);
  }, [store, active, intervalMs]);
}

export function useAccess() {
  const sub = useAppState((s) => s.subscription);
  const online = useAppState((s) => s.online);
  const now = useNow(30_000);
  const access = hasAccess(sub, now);
  return {
    subscription: sub,
    hasAccess: access,
    canEdit: access && online,
    paying: isPaying(sub),
    /** nunca assinou: planos ao abrir (AC-207) e desconto da 1ª assinatura (AC-232) */
    neverSubscribed: neverSubscribed(sub),
    /** a assinatura acabou: pop-up "Sua assinatura chegou ao fim!" (AC-208) */
    subscriptionEnded: subscriptionEnded(sub, now),
  };
}
